export default __webpack_public_path__ + "static/media/1e.f15b0c11.jpg";